export default {
  "": "",
  "24hChange": "Изменение, 24ч",
  "24hTurnover": "Оборот, 24ч",
  "action": "Действие",
  "AddLoan": "Увеличить",
  "AdjustLoanFail": "Невозможно изменить сумму обеспечения. Повторите попытку позже. ",
  "all": "Все",
  "apply": "Подтвердить",
  "assets": "Монета",
  "available": "Доступно",
  "balance": "Доступный баланс",
  "bi_all": "Все",
  "bi_average_change": "Сред. изм. за 24 ч.",
  "bi_down_amount": "Падение объёма",
  "bi_down_num": "Упали",
  "bi_eth_gas": "Газ ETH",
  "bi_google_tips": "Числа отображают поисковой интерес к теме по отношению к наиболее высокому показателю на графике в определенное время и в определённом регионе. Показатель 100 означает наивысший уровень популярности запроса.",
  "bi_google_trends": "BTC в Google Trends",
  "bi_market_cap": "Капитализация мирового рынка криптовалют (USDT)",
  "bi_market_distribution": "Распределение рыночной капитализации",
  "bi_market_sentiment": "Рыночные настроения",
  "bi_market_trends": "Тренды криптовалютного рынка",
  "bi_market_volatility": "Волатильность на криптовалютном рынке",
  "bi_normal_amount": "Монеты без изменения объёма",
  "bi_normal_num": "Без изменений",
  "bi_page_title": "Тренды и движения крипторынка, трекер волатильности {'|'} Bybit",
  "bi_price_distribution": "Распределение (изменение цены)",
  "bi_ranking": "Рейтинг",
  "bi_ranking_sector": "Сектор",
  "bi_ranking_tips": "В этом секторе отображаются только 3 лидера рыночной капитализации.",
  "bi_sentiment1": "Сильный страх",
  "bi_sentiment2": "Страх",
  "bi_sentiment3": "Нейтрально",
  "bi_sentiment4": "Жадность",
  "bi_sentiment5": "Сильная жадность",
  "bi_social": "Популярно в социальных сетях",
  "bi_td_trade": "Сделка",
  "bi_th_action": "Действие",
  "bi_th_change": "Изменение, 24 ч",
  "bi_th_currency": "Валюта",
  "bi_th_market": "Рын. капитализация",
  "bi_th_price": "Цена",
  "bi_th_sector": "Сектор",
  "bi_th_up_down": "Выросло/упало",
  "bi_th_volume": "Торговый объём, 24 ч",
  "bi_top_20": "Рын. капитализация",
  "bi_top_gain": "Лидер роста (в %)",
  "bi_total_market": "Общ. рын. капитализ.",
  "bi_trading_distribution": "Распределение торгового объёма",
  "bi_trading_vol": "Торговый объём мирового рынка криптовалют за 24 ч. (USDT)",
  "bi_twitter_explore": "Обзор Twitter",
  "bi_twitter_tips1": "Новые популярные темы в Twitter",
  "bi_twitter_tips2": "Трендовые темы в Twitter",
  "bi_twitter_topics": "Актуальное в Twitter",
  "bi_up_amount": "Рост объёма",
  "bi_up_num": "Выросли",
  "bi_view": "Смотреть",
  "bi_volume_distribution": "Распределение (изменение объёма)",
  "botValidateErrCode101": "Минимальная цена слишком низкая",
  "botValidateErrCode102": "Минимальная цена слишком высокая",
  "botValidateErrCode103": "Максимальная цена слишком низкая",
  "botValidateErrCode104": "Максимальная цена слишком высокая",
  "botValidateErrCode105": "Недостаточно сеток",
  "botValidateErrCode106": "Слишком много сеток",
  "botValidateErrCode107": "Сумма инвестиций слишком низкая и не соответствует инвестиционным требованиям",
  "botValidateErrCode108": "Сумма инвестиций слишком высокая и превышает инвестиционный лимит по этому контракту",
  "botValidateErrCode109": "Цена тейк-профит слишком низкая",
  "botValidateErrCode110": "Цена тейк-профит слишком высокая",
  "botValidateErrCode111": "Цена стоп-лосс слишком низкая",
  "botValidateErrCode112": "Цена стоп-лосс слишком высокая",
  "botValidateErrCode113": "Цена входа слишком низкая",
  "botValidateErrCode114": "Цена входа слишком высокая",
  "cancel": "Нет",
  "cancelAll": "Отменить все",
  "cancelOrder": "Отменить",
  "chart": "График",
  "close": "Закрыть",
  "confirm": "Да",
  "contest-about-to-start": "СКОРО",
  "contest-accumulate-volume": "Общий объём транзакций",
  "contest-accumulate-volume-start": "Регистрация успешна! Сейчас будет подсчитан ваш объем спотовой торговли.",
  "contest-achieve-standards": "Вы подходите",
  "contest-activity-rules": "Правила",
  "contest-activity-rules-title": "Правила",
  "contest-activity-time": "Сроки проведения",
  "contest-countdown": "До окончания состязания",
  "contest-countdown-day": "ДН.,",
  "contest-cumulative-volume": "Суммарный торговый объём ({unit})",
  "contest-current-volume": "Текущий объём транзакций",
  "contest-date-range": "{time} {utc}, {date} {month} ",
  "contest-dialog-btn-text": "Подтвердить",
  "contest-difference-to-foward": "Отставание от ближайшего ТОП-трейдера — {num} {unit}",
  "contest-earn-rewards": "Награды ({unit})",
  "contest-ended": "Событие завершено",
  "contest-find-more-premium-assets": "Увеличивайте объем торговли на споте!",
  "contest-latest-update": "Данные будут обновлены в {time}{utc}.",
  "contest-less": "Меньше",
  "contest-limit-desc": "Для получения наград ваш объем спотовой торговли должен составлять не менее {amount} {unit}.",
  "contest-list-show-more": "Показать еще",
  "contest-login": "Вход",
  "contest-month": "Январь,Февраль,Март,Апрель,Май,Июнь,Июль,Август,Сентябрь,Октябрь,Ноябрь,Декабрь",
  "contest-my-rank": "Мой рейтинг",
  "contest-no-rank": "Рейтинга пока нет. Следите за новостями!",
  "contest-no-rank-yet": "Еще нет рейтинга",
  "contest-not-registered": "Вы не зарегистрировались на это трейдинговое состязание.",
  "contest-num-of-participants": "Кол-во участников",
  "contest-popup-success": "Торговать",
  "contest-ranking": "Рейтинг",
  "contest-register": "Участвовать",
  "contest-registered": "Зарегистрирован",
  "contest-registration-ends": "Регистрация окончена",
  "contest-rewards-earned": "Полученные награды ({unit})",
  "contest-share": "Поделиться",
  "contest-symbol-scope": "Спотовая пара",
  "contest-terms-conditions": "<p>Условия</p>",
  "contest-to-spot-trade": "Событие началось. Внесите депозит и начните торговать!",
  "contest-u-earned-king": "Вы получили награду «Трейдер-рекордсмен»",
  "contest-u-earned-sunny": "Вы получили награду «Успешный трейдер»",
  "contest-unqualified": "Ой! Вы не можете принять участие в событии. Если у вас есть вопросы, свяжитесь со Службой поддержки.",
  "contest-updated-daily-at": "*Последнее обновление в {time} (UTC0).",
  "contest-will-start-tips": "Регистрация успешна! Событие начнется в {time}. Следите за новостями!",
  "contest-your-rewards": "Причитающиеся вам награды",
  "contract_account": "деривативный аккаунт",
  "createErrorCode400": "Отправленные пользователем данные содержат неверные параметры. Подробная информация содержится в сообщении об ошибке и деталях ошибки.",
  "createErrorCode401": "Недостаточный баланс.",
  "createErrorCode402": "Количество созданных пользователем ботов достигло максимума.",
  "createErrorCode403": "ЗАПРЕЩЕНО",
  "createErrorCode404": "Запрашиваемый ресурс не найден.",
  "createErrorCode407": "Такой тип пользователей не может создавать субаккаунты с grid-ботами.",
  "createErrorCode408": "Выбраны дублирующиеся регулярные инвестиционные цели",
  "createErrorCode409": "Неверная максимальная сумма инвестиций",
  "createErrorCode410": "Неверная максимальная сумма инвестиций",
  "createErrorCode411": "Бот закрыт",
  "createErrorCode412": "Единый маржинальный аккаунт обновляется",
  "createErrorCode500": "Внутренняя ошибка сервера",
  "createErrorCode501": "Внутренняя задержка обработки",
  "createErrorCode503": "Невозможно закрыть DCA-бот в данный момент, поскольку он, вероятно, совершает транзакцию по покупке актива",
  "currency": "Монеты",
  "dailyRate": "Дневная проц. ставка",
  "deposit": "Депозит",
  "detail": "Детали",
  "direction": "Направление",
  "end": "Время окончания",
  "fiat": "Фиат",
  "filled": "Выполненный",
  "filter": "Фильтры",
  "from": "Время начала",
  "global_setting_quick_order_desc": "<p>1.Рыночный ордер (быстрое размещение ордера)</p>\n<p>2.Обращаем внимание, что конечный объём покупки может немного отличаться от указанного вами размера ордера.</p>",
  "global_setting_quick_order_label": "Мгновенное размещение ордера",
  "global_setting_title": "Индивидуальные настройки (применить для спота)",
  "hint": "Напоминание",
  "innovateQuota": "Доступная квота",
  "kline": "График",
  "l_version_tip": "Пожалуйста, обновите приложение Bybit, чтобы участвовать в Bybit Launchpad.",
  "LastTradedPrice": "Цена",
  "leverage": "Кредитное плечо",
  "leverage_can_borrow": "Доступно к займу",
  "leverage_can_deposit": "Маржа",
  "leverage_data": "Данные маржи",
  "leverage_forced_order": "Ордер на ликвидацию",
  "leverage_go_trade": "Торговать",
  "leverage_loan_limit": "Макс. сумма займа",
  "leverage_min_borrow": "Мин. сумма займа",
  "leverage_off_trade_tip": "Подключите кредитное плечо и торгуйте с использованием заёмных средств.",
  "leverage_yearly_rate": "Годовая проц. ставка",
  "leverageCloseErrInfo": "Сбой! Выполните возмещение всех средств перед отключением Маржинальной торговли.",
  "leverageCloseTips": "Failed to disable Margin Trading, as there are active Spot Margin orders in your account.",
  "leverageLoanTips": "Действие не может быть выполнено, поскольку уровень использования начальной маржи/поддерживающей маржи Единого маржинального аккаунта превысил пороговое значение.",
  "leverageLP_banner_title": "Маржинальная торговля на споте Bybit",
  "leverageLP-banner-desc": "Инвестируйте с заёмными средствами и повышайте доходность",
  "leverageLP-faq-a1": "Подробная информация представлена в <a href=\"{url}\" target=\"_blank\" > списке залоговых и заёмных активов (маржинальная торговля).</a>",
  "leverageLP-faq-a10": "Переходите в раздел Ордера –> Спотовый ордер –> История погашений –> Ликвидации.",
  "leverageLP-faq-a11": "Чтобы посмотреть историю займов и погашений, перейдите в раздел Ордера → Спотовые ордера → История погашений.",
  "leverageLP-faq-a2": "На маржинальную торговлю на Bybit распространяются спотовые торговые комиссии, проценты и комиссии за закрытие позиции. Подробная информация представлена в статье <a href=\"{url}\" target=\"_blank\" >Маржинальная торговля на споте Bybit: проценты и ставки комиссий.</a>",
  "leverageLP-faq-a3": "Чтобы воспользоваться кредитным плечом для маржинальной торговли, необходимо предоставить в качестве обеспечения криптоактивы с вашего спотового аккаунта Bybit.",
  "leverageLP-faq-a4": "Нет. Если активировано институциональное кредитование, воспользоваться торговлей с кредитным плечом уже невозможно. Если вы хотите, чтобы ваш UID был удалён из списка пользователей институционального кредитования, напишите по адресу institutional_services{'@'}bybit.com и переходите на маржинальную торговлю Bybit.",
  "leverageLP-faq-a5": "Процентные ставки зависят от VIP уровня пользователя. Больше информации представлено в разделе о <a href=\"{url}\" target=\"_blank\"> кредитном плече.</a>",
  "leverageLP-faq-a6": "Расчёт процентов осуществляется каждый час. Обратите внимание, что займы, взятые менее чем на один час, также рассчитываются по почасовой ставке.",
  "leverageLP-faq-a7": "Вы получите два (2) уведомления о рисках по SMS и электронной почте:\n\n(1) Когда уровень риска на вашем спотовом аккаунте составит ≥ 87%, будет отправлено уведомление о риске. Вы получите SMS-сообщение и уведомление по электронной почте с напоминанием добавить обеспечение (перевести больше залоговых активов), чтобы предотвратить принудительное закрытие позиции.\n\n(2) Когда уровень риска на спотовом аккаунте достигнет ≥ 95%, вы получите SMS и электронное письмо о принудительной ликвидации вашей позиции.\n\nПодробнее о процессе и критериях можно узнать в статье <a href=\"{url}\" target=\"_blank\"> Риск и принудительная ликвидация (торговля с кредитным плечом на споте).</a>",
  "leverageLP-faq-a8": "Фонд маржинального страхования (MAF) покрывает убытки по позиции трейдера после её принудительной ликвидации позиции, если на аккаунте пользователя недостаточно средств для погашения займа.\n\nЕсли ваш спотовый аккаунт окажется некредитоспособным, платформа воспользуется средствами из фонда маржинального страхования для погашения вашего долга. Таким образом, для покрытия нужд фонда маржинального страхования взимается комиссия за ликвидацию.",
  "leverageLP-faq-a9": "Если после того как для погашения займа использовалась маржа, но у вас всё равно остался долг, оставшиеся убытки будут покрыты из фонда маржинального страхования.",
  "leverageLP-faq-q1": "Какие криптовалюты можно использовать в качестве обеспечения или заёмных активов в маржинальной торговле?",
  "leverageLP-faq-q10": "Где можно посмотреть историю ликвидаций?",
  "leverageLP-faq-q11": "Где можно посмотреть историю займов и погашений?",
  "leverageLP-faq-q2": "Взимаются ли комиссии за использование маржинальной торговли на Bybit?",
  "leverageLP-faq-q3": "Какой аккаунт Bybit необходимо использовать для маржинальной торговли?",
  "leverageLP-faq-q4": "Можно ли торговать с маржой или кредитным плечом, если активировано институциональное кредитование?",
  "leverageLP-faq-q5": "Какие процентные ставки распространяются на маржинальную торговлю Bybit?",
  "leverageLP-faq-q6": "Через какое время начинают начисляться проценты?",
  "leverageLP-faq-q7": "При каких условиях я получу уведомление о риске для маржинальной торговли?",
  "leverageLP-faq-q8": "Что такое фонд маржинального страхования?",
  "leverageLP-faq-q9": "Что происходит, если на спотовом аккаунте недостаточно средств для принудительной ликвидации позиции?",
  "leverageLP-faq-title": "FAQ",
  "leverageLP-feature-title": "Чем привлекательна маржинальная торговля?",
  "leverageLP-feature1": "Увеличение торговой прибыли",
  "leverageLP-feature2": "Поддержка лонг-/шорт-позиций",
  "leverageLP-feature3": "Более эффективное использование капитала",
  "leverageLP-feature4": "Диверсификация активов",
  "leverageLP-whats-leverage": "Что такое маржинальная торговля на споте?",
  "leverageLP-whats-leverage-c": "Маржинальная торговля на споте от Bybit — это деривативный продукт на спотовой платформе, позволяющий трейдерам использовать кредитное плечо под обеспечение собственных криптоактивов. Заимствованные средства будут использоваться для увеличения торговой прибыли по позициям с кредитным плечом на низко- или высоковолатильном рынке.",
  "leverageTest": "Опрос о Маржинальной торговле",
  "leverageTestSubTitle": "Правильно ответьте на все вопросы, чтобы приступить к Маржинальной торговле.",
  "leverageTryAgain": "Системная ошибка. Попробуйте позже.",
  "liquidate": "Ликвидировано",
  "liquidationErrorInfo": "Сбой! На вашем аккаунте запущена ликвидация.",
  "load_more": "Загрузить ещё",
  "loan": "Оформить заём",
  "loan_limit": "Срок займа",
  "loan_spot_account": "спотовый аккаунт",
  "loanLualityDeposit1": "Сумму обеспечения можно уменьшить, только если текущий коэффициент LTV ниже начального. ",
  "loanLualityDeposit2": "Максимальная сумма, на которую можно уменьшить обеспечение, равна сумме, которая потребуется для достижения изначального коэффициента LTV.",
  "loanLualityDeposit3": "Сумму обеспечения нельзя уменьшить, если сниженная сумма меньше настраиваемой маржи.",
  "loanTime": "Время",
  "login": "Войти",
  "lp_go_home": "Назад",
  "lpn_one_progress_info": "Результаты ожидаются в",
  "lpn_order_btn": "Моя подписка",
  "lpn_order_btn_cancel": "Отменить",
  "lpn_order_btn_confirm": "Подтвердить",
  "lpn_order_submit_error": "Не получилось!",
  "lpn_order_submit_error_desc": "Системная ошибка. Повторите попытку позже.",
  "lpn_unfold": "Подробнее",
  "lt_all": "Все",
  "lt_amount": "Сумма",
  "lt_amount_not_enough": "На доступном балансе недостаточно {currency}.",
  "lt_entry_tips": "Для {symbol} ({direction}) доступно кредитное плечо. Торгуйте!",
  "lt_freerate": "Ставка комиссии",
  "lt_lowcase_redemption": "выкуп",
  "lt_lowcase_subscription": "подписка",
  "lt_open_success_txt": "Токены с кредитным плечом активированы!",
  "lt_orders_submitted": "{ordertype} ордер на сумму {quantity} отправлен.",
  "lt_redemption": "Выкуп",
  "lt_redemption_failed_change_position": "Для указанной пары запущен механизм ребалансировки. В настоящее время выкуп недоступен. Повторите попытку позже.",
  "lt_redemption_failed_closed": "Выкуп выбранного актива в настоящее время недоступен. Повторите попытку позже.",
  "lt_redemption_failed_input_quantity": "Укажите сумму выкупа",
  "lt_redemption_failed_net_worth": "Некорректная чистая стоимость актива. В настоящее время выкуп недоступен. Повторите попытку позже.",
  "lt_redemption_failed_wear_position": "На вашем аккаунте проходит процедура ликвидации. В настоящее время выкуп недоступен. Повторите попытку позже.",
  "lt_redemption_max_quanlity": "Сумма выкупа для выбранного актива за одну транзакцию не может быть меньше {quantity}.",
  "lt_redemption_min_quanlity": "Сумма выкупа для выбранного актива за одну транзакцию не может превышать {quantity}.",
  "lt_redemption_tips": "Фактическая сумма выкупа может несколько отличаться.",
  "lt_subscription": "Подписка",
  "lt_subscription_failed_change_position": "Для указанной пары запущен механизм ребалансировки. В настоящее время подписка недоступна. Повторите попытку позже.",
  "lt_subscription_failed_close_position": "На вашем аккаунте проходит процедура ликвидации. В настоящее время подписка недоступна. Повторите попытку позже.",
  "lt_subscription_failed_closed": "Подписка для выбранного актива в настоящее время недоступна. Повторите попытку позднее.",
  "lt_subscription_failed_input_amount": "Укажите сумму подписки",
  "lt_subscription_failed_invalid_value": "Некорректная чистая стоимость актива. В настоящее время подписка недоступна. Повторите попытку позже.",
  "lt_subscription_failed_large_amount": "Слишком большая сумма подписки. Степень риска будет увеличена. Есть риск ликвидации.",
  "lt_subscription_failed_wear_position": "Ваш аккаунт имеет отрицательный капитал. В настоящее время подписка недоступна. Повторите попытку позже.",
  "lt_subscription_max_amount": "Максимальная сумма подписки для выбранного актива за одну транзакцию не может превышать {amount}.",
  "lt_subscription_min_amount": "Минимальная сумма подписки для выбранного актива за одну транзакцию не может быть меньше {amount}.",
  "lt_subscription_redemption": "Подписка и выкуп",
  "lt_subscription_redemption_records": "История подписок и выкупа",
  "lt_subscription_tips": "Фактическая сумма подписки может несколько отличаться.",
  "lt_subscription_usdt_not_enough": "На доступном балансе недостаточно USDT. Сначала внесите депозит или переведите средства.",
  "lt-landing-banner-desc": "Кредитное плечо без риска ликвидации",
  "lt-landing-banner-title": "Токены с кредитным плечом Bybit",
  "lt-landing-faq-a1": "NAV, или чистая стоимость активов, означает стоимость токена с кредитным плечом. NAV токена с кредитным плечом меняется в соответствии с колебаниями цен на рынке бессрочных контрактов.",
  "lt-landing-faq-a2": "Рассмотрим в качестве примера токен BTC: \n\nBTC3L — это токен с кредитным плечом, удерживающий лонг позиции по бессрочным BTCUSDT контрактам с трёхкратным кредитным плечом.\n\nBTC3S — это токен с кредитным плечом, удерживающий шорт позиции по бессрочным BTCUSDT контрактам с трёхкратным кредитным плечом.",
  "lt-landing-faq-a3": "Торговля токенами с кредитным плечом осуществляется напрямую через спотовый аккаунт.",
  "lt-landing-faq-a4": "Об этом можно прочитать в статье <a href=\"{url}\" target=\"_blank\" >Различия между токенами с кредитным плечом и деривативами</a>.",
  "lt-landing-faq-a5": "Подробнее о комиссиях можно прочитать в статье <a href=\"{url}\" target=\"_blank\" >Комиссии для токенов с кредитным плечом на Bybit </a>.",
  "lt-landing-faq-a6": "Рисков ликвидации нет. \n\nВозьмём в качестве примера BTC3L. Целевой диапазон кредитного плеча этого токена составляет [2,4]. Механизм ребалансировки срабатывает, когда фактическое значение кредитного плеча выходит за пределы диапазона 2х — 4х и корректирует позицию таком образом, чтобы кредитное плечо составляло 3х.\n\nПримечание: имейте в виду, что чистая стоимость токена с кредитным плечом может упасть до нуля. В этом случае токен возмещению не подлежит.",
  "lt-landing-faq-a7": "Ребалансировка — это процесс, динамически корректирующий позиции по бессрочным контрактам для достижения целевого значения кредитного плеча. Механизм ребалансировки запускается автоматически, когда фактическое кредитное плечо выходит за пределы целевого кредитного плеча. \n\nБолее подробную информацию можно найти в статье <a href=\"{url}\" target=\"_blank\"> Механизм ребалансировки токенов с кредитным плечом</a>.",
  "lt-landing-faq-a8": "В настоящее время вывод не поддерживается.",
  "lt-landing-faq-q1": "Что такое чистая стоимость активов (NAV)?",
  "lt-landing-faq-q2": "Как расшифровывается тикер токенов с кредитным плечом?",
  "lt-landing-faq-q3": "Какой аккаунт необходимо использоваться для торговли токенами с кредитным плечом на Bybit?",
  "lt-landing-faq-q4": "Чем отличаются токены с кредитным плечом и торговля деривативами на Bybit?",
  "lt-landing-faq-q5": "Какие комиссии необходимо оплачивать при торговле токенами с кредитным плечом?",
  "lt-landing-faq-q6": "При каких условиях мои позиции по токенам с кредитным плечом могут быть ликвидированы?",
  "lt-landing-faq-q7": "Что такое механизм ребалансировки?",
  "lt-landing-faq-q8": "Можно ли вывести токены с кредитным плечом?",
  "lt-landing-faq-title": "FAQ",
  "lt-landing-feature-title": "Преимущества токенов с кредитным плечом",
  "lt-landing-feature1": "Доступ к кредитному плечу, которое может увеличить прибыль",
  "lt-landing-feature2": "Отсутствие рисков ликвидации",
  "lt-landing-feature3": "Высокая эффективность капитала",
  "lt-landing-feature4": "Простая торговля",
  "lt-landing-learn-more": "Подробнее",
  "lt-landing-operation": "Действие",
  "lt-landing-symbol": "Торговая пара",
  "lt-landing-whats-lt": "Что такое токен с кредитным плечом?",
  "lt-landing-whats-lt-c": "Токен с кредитным плечом — это деривативный продукт, который предоставляет доступ к кредитному плечу для базового актива без требований к марже. Он может потенциально увеличить прибыль без риска ликвидации. \n\nКаждый токен с кредитном плечом представляет собой группу позиций по бессрочным контрактам. \n\nЧистая стоимость активов (NAV) токена с кредитным плечом меняется в соответствии с колебаниями цен на рынке бессрочных контрактов.",
  "lt-learning-video-title": "Обучающее видео о токенах с кредитным плечом для новичков",
  "ltLearningVideo": "Обучающее видео",
  "ltNav": "Стоимость NAV",
  "ltOpenRiskContent": "Токены с кредитным плечом предоставляют пользователям доступ к базовому активу с кредитным плечом.\n\nBybit оставляет за собой право изменять Условия и вносить следующие правки в зависимости от условий рынка без предварительного уведомления пользователей:\n\n1. Проводить делистинг токенов с кредитным плечом.\n\n2. Добавлять или изменять ограничения, например, вводить лимиты на количество позиций. Если объявляются подобные изменения, вся подробная информация предоставляется в нашем блоге. В случае введения лимитов на количество позиций фактическое количество, к которому вы сможете иметь доступ, может отличаться от официально заявленного по техническим причинам. Имейте в виду связанные с этим риски. \n\n3. Динамически изменять позиции по базовому активу в целях достижения целевого кредитного плеча. \n\n4. Удалять любые пункты из настоящих Условий.\n\nИзучите все особенности токенов с кредитным плечом как финансового продукта и принимайте взвешенные инвестиционные решения с учётом ваших знаний в этой области и допустимого уровня риска. Bybit не несёт ответственности за убытки, понесённые при торговле токенами с кредитным плечом. \n\nПродолжая, вы соглашаетесь с <a href={url} target=\"_blank\">Условиями использования</a> токенов с кредитным плечом.",
  "ltOpenRiskSubmit": "Принять условия и активировать токены с кредитным плечом",
  "ltOpenRiskTitle": "Соглашение об использовании токенов с кредитным плечом",
  "ltTestDialogContent": "Вы уверены, что хотите выйти? Ваши ответы не сохранятся.",
  "ltTestDialogContinue": "Нет",
  "ltTestDialogExit": "Да",
  "ltTestDialogTitle": "Подтверждение",
  "ltTestDone": "Дано ответов: <span>{num} из {numAll}</span>",
  "ltTestDoneFail": "Ой! Правильных ответов всего {num} из {numAll}. Пройдите викторину ещё раз.",
  "ltTestPassContent": "Ура! Вы успешно прошли опрос!",
  "ltTestPassRead": "Подробнее",
  "ltTestPassReject": "Пропустить",
  "ltTestResubmit": "Попробуйте ещё раз",
  "ltTestSubmit": "Отправить",
  "ltTestSubTitle": "Правильно ответьте на все вопросы, чтобы начать торговать Токенами с кредитным плечом.",
  "ltTestTitle": "Викторина",
  "ltUnderlying": "Базовый актив",
  "margin_coin": "Монета",
  "margin_discount": "Множитель",
  "margin_discount_eg": "Пример:",
  "margin_discount_eg_body": "Допустим, на спотовом аккаунте трейдера Андрея есть 1 BTC, 1000 BIT и 100 TRX. \nПредположим, что рыночная цена BTC, BIT и TRX составляет 50 000 USDT, 5 USDT и 0,50 USDT соответственно. В таком случае, общая стоимость обеспечения для маржинальной торговли будет: \n(1 (количество) * 50 000 (цена) * 1 (множитель) * 1 ) + (1000 (количество) * 5 (цена) * 0,9 (множитель) + (100 (количество) * 0,5 (цена) * 0 (множитель) = 54 500 USDT.",
  "margin_discount_rate": "Параметры маржи",
  "margin_lq_order": "Ордер на ликвидацию",
  "MARKET": "Рыночная цена",
  "max": "Максимум",
  "more": "Ещё",
  "network_error": "Ошибка запроса. Попробуйте позже.",
  "NEW": "Активный",
  "nextPage": "Вперед",
  "nodata": "Записей не найдено",
  "none": "Не найдено",
  "noRecordFound": "Нет данных",
  "og_description": "Безопасно покупайте, продавайте и торгуйте {symbol} на споте Bybit. Торгуйте уверенно с низкой комиссией и высокой ликвидностью.",
  "og_title": "{symbol} {'|'} Торгуйте с низкой комиссией {'|'} Bybit Спот",
  "ol_agree": "Я прочитал и согласен с",
  "ol_agrmt": "Соглашение о займе цифровых активов",
  "ol_agrmt_2": "<Соглашение о займе цифровых активов>",
  "ol_agrmt_err": "Необходимо подписать соглашение о займе цифровых активов",
  "ol_amt": "Сумма займа",
  "ol_amt_err": "Сумма займа ({condition}) составляет {amount} {unit}",
  "ol_amt_tip": "Введите сумму займа",
  "ol_app_sub": "Заявка на получение займа подана",
  "ol_app_time": "Время подачи заявки",
  "ol_apply_title": "Онлайн-заявка на институциональные займы",
  "ol_cancel": "Вы уверены, что хотите закрыть эту заявку?",
  "ol_cfm_product": "Продукты Институционального кредитования",
  "ol_check_app": "Проверить заявку",
  "ol_coin": "Монета",
  "ol_col_amt": "Сумма",
  "ol_col_app_tm": "Время подачи заявки",
  "ol_col_dl": "Срок займа",
  "ol_col_no": "Номер ордера",
  "ol_col_pn": "Название продукта",
  "ol_col_sub": "Субаккаунты",
  "ol_confirm": "Подтверждение заявки на получение займа",
  "ol_contact_desc": "Убедитесь в том, что вся информация актуальна и действительна, так как все предупреждения о рисках будут отправляться на ваш адрес электронной почты и мобильный телефон.",
  "ol_contact_tip": "Свяжитесь с нашей командой по развитию бизнеса",
  "ol_contact_title": "Контактные данные",
  "ol_detail_title": "Детали заявки на получение займа",
  "ol_eg": "Пример",
  "ol_email": "Адрес электронной почты",
  "ol_email_err_invalid": "Неверный адрес электронной почты",
  "ol_email_tip": "Введите ваш адрес электронной почты",
  "ol_max": "maximum",
  "ol_mgr": "ID вашего менеджера развития бизнеса",
  "ol_mgr_err_invalid": "Недействительный ID",
  "ol_mgr_link": "Нажмите, чтобы получить ID вашего менеджера развития бизнеса",
  "ol_mgr_tip": "Введите ID вашего менеджера развития бизнеса",
  "ol_min": "minimum",
  "ol_mine_title": "Мои заявки на получение займа",
  "ol_month": "{month} месяцев",
  "ol_no_code_rcd": "Код страны не найден",
  "ol_notice_desc": "<li>Институциональное кредитование доступно только институциональным трейдерам.</li>\n<li>Институциональные трейдеры, подающие заявки на получение займов, должны владеть активами на сумму не менее 500 000 USDT.</li>\n<li>Займы могут быть использованы на спотовом или деривативном рынке в зависимости от выбранного продукта.</li>",
  "ol_notice_desc_lmt": "<li>Минимальная сумма займа составляет 1 000 000 USDT, а максимальная - 20 000 000 USDT.</li>",
  "ol_notice_title": "Инструкции по институциональному кредитованию",
  "ol_phone": "Номер мобильного телефона",
  "ol_phone_err": "Выберите код страны и введите номер мобильного телефона",
  "ol_phone_err_invalid": "Недействительный номер мобильного телефона",
  "ol_phone_tip": "Введите ваш номер мобильного телефона",
  "ol_prd": "Выберите продукт Институционального кредитования",
  "ol_prd_3x_spot": "Институциональное кредитование: кредитное плечо 3x (спот)",
  "ol_prd_3x_spot_futures": "Институциональное кредитование: кредитное плечо 3x (спот и деривативы)",
  "ol_prd_5x_spot": "Институциональное кредитование: кредитное плечо 5x (спот)",
  "ol_prd_link": "Узнать больше о продукте",
  "ol_prd_tip": "Если вы переведёте свои активы на спотовом аккаунте в немаржинальные активы, риск ликвидации возрастёт. Чтобы подробнее узнать о поддерживаемых маржинальных активах на спотовом рынке Bybit, перейдите <a href={url} target=\"_blank\">по ссылке</a>.",
  "ol_recent_year_only": "Результаты поиска включают заявки на получение займа только за последний год.",
  "ol_status": "Статус заявки",
  "ol_status_list": "Все, Рассмотренные, Полученные, Отклоненные, Выплаченные",
  "ol_subacc": "Добавить субаккаунт(-ы)",
  "ol_subacc_tip": "Введите Bybit UID субаккаунта, который вы хотите добавить. Если вам нужно добавить несколько субаккаунтов, то свяжитесь, пожалуйста, с нашей командой по развитию бизнеса.",
  "ol_term": "Срок займа",
  "ol_term_err": "Выберите срок для заявки на займ.",
  "ol_unit_month": "Период: месяц",
  "ol_view_agrmt": "Открыть вложения к соглашению",
  "operationSuccess": "Успешно",
  "or": "или",
  "orderBook": "Книга ордеров",
  "orderHistory": "История ордеров",
  "orderId": "ID ордера",
  "orderSuccessful": "Ордера успешно отправлены",
  "orderType": "Тип ордера",
  "otcErrorInfo": "Вы активировали Институциональное кредитование, поэтому Маржинальная торговля недоступна.",
  "outstanding": "К погашению",
  "pa_accumated_profit_descript": "Суммарная прибыль — это сумма прибыли, полученная ежедневно в течение определённого периода. В графике показаны данные только за предыдущий день.",
  "pa_accumated_profit_select": "Фактическая суммарная прибыль",
  "pa_accumated_profit_title": "Суммарная прибыль",
  "pa_accumulated_account": "Суммарный ROI спотового аккаунта",
  "pa_accumulated_btc": "Суммарные изменения цены BTC (%)",
  "pa_accumulated_btc_select": "Фактические суммарные изменения цены BTC (%)",
  "pa_accumulated_pnl": "P&L за 7 дн.",
  "pa_accumulated_pnl_select": "Фактический суммарный ROI",
  "pa_accumulated_roi_descript": "Суммарный ROI оценивает эффективность прибыли, полученной от инвестиций за определённый период. В графике показаны данные только за предыдущий день.",
  "pa_accumulated_roi_title": "Суммарный ROI",
  "pa_assets_distribution_descript": "Распределение активов — это вес каждого актива на спотовом аккаунте относительно общей суммы всех активов в USDT.",
  "pa_assets_distribution_title": "Распределение активов",
  "pa_daily_pnl": "P&L за сегодня",
  "pa_daily_profit_descript": "В графике суточного P&L показаны данные только за предыдущий день.",
  "pa_daily_profit_select": "P&L за день",
  "pa_daily_profit_title": "Суточный P&L",
  "pa_last_30_day": "Последние 30 дней",
  "pa_last_7_day": "Последние 7 дней",
  "pa_last_90_day": "Последние 90 дней",
  "pa_others": "Другое",
  "pa_page_description": "Будьте в курсе эффективности вашего спотового портфеля и адаптируйте свою инвестиционную стратегию к текущим изменениям на рынке.",
  "pa_page_title": "Анализ P&L спотовых активов",
  "pa_quantity": "Количество {Coin}",
  "pa_spot_pnl_descript": "1. Данные P&L на споте будут обновляться ежедневно в 00:00 UTC.\n2. Самые актуальные данные о P&L на споте будут рассчитываться с 00:00 UTC до 06:00 UTC и будут отображаться после 04:00 UTC каждый день.",
  "pa_spot_pnl_title": "Анализ P&L на споте",
  "pa_total_assets": "Всего активов",
  "pa_total_assets_value_descript": "Общая стоимость активов означает общую стоимость всех активов на спотовом аккаунте (включая заёмные активы). Она изменяется в зависимости от выводов, переводов (на аккаунт и из него), займов и маржинальных позиций.",
  "pa_total_assets_value_select": "Стоимость активов",
  "pa_total_assets_value_title": "Общая стоимость активов",
  "pa_update_on": "Последнее обновление:",
  "pa_value": "Стоимость {Coin}",
  "pa_weightage": "Вес {Coin}",
  "pauseTradeTip": "В настоящий момент сделки с {symbol} недоступны. Более подробная информация указана в нашем <a href={url} target=\"_blank\">блоге</a>.",
  "placeHolder": "Выбрать",
  "prevPage": "Назад",
  "price": "Цена",
  "quantity": "Кол-во",
  "ReduceLoan": "Уменьшить",
  "ReduceLoanAssets": "Уменьшить сумму обеспечения",
  "ReduceLoanTip1": "Сумму обеспечения можно уменьшить, только если текущий коэффициент LTV ниже начального.  ",
  "ReduceLoanTip2": "Сумму обеспечения можно уменьшить, только если сниженная сумма меньше настраиваемой маржи.",
  "ReduceLoanTip3": "Сумму обеспечения нельзя уменьшить, если текущий коэффициент LTV превышает начальный или равен ему. Попробуйте ещё раз. ",
  "ReduceLoanTip4": "Сумму обеспечения можно изменить на странице «Ордера». Увеличить обеспечение можно в любой момент, а уменьшить — только когда текущий коэффициент LTV ниже начального. ",
  "repayment": "Погасить",
  "reset": "Сбросить",
  "reverse_contract_account": "инверсный деривативный аккаунт",
  "riskWarning": "Подтверждение",
  "search": "Поиск",
  "side": "Направление",
  "signup": "Регистрация",
  "spot_account": "Спотовый аккаунт",
  "status": "Статус",
  "stop_limit": "TP/SL",
  "stop_limit_tips_2": "Невозможно активировать маржинальную торговлю при наличии ордеров тейк-профит и стоп-лосс.",
  "success": "Успешно",
  "sure": "sure",
  "tests1": "",
  "times": "раз",
  "timestamp": "Время",
  "title_404": "404 {'|'} Спот на Bybit  ",
  "to": "до",
  "toastTheSymbolNotExist": "Выбранная спотовая пара в настоящее время недоступна для торговли.",
  "total": "Всего",
  "tradeChange": "Изменение %",
  "tradeId": "ID транзакции",
  "transfer": "Перевести",
  "usdc_contract_account": "деривативный USDC аккаунт",
  "VIP99": "Supreme VIP",
  "volume": "Исполнено",
  "vote_btn_trade": "Торговать"
}